import { LayoutDashboard, Building2, Wallet, ShieldCheck, Settings } from 'lucide-react';
import type { MasterTab } from '../types';

interface MasterTabBarProps {
  current: MasterTab;
  onChange: (tab: MasterTab) => void;
}

const TABS = [
  { id: 'geral' as MasterTab, icon: LayoutDashboard, label: 'Geral' },
  { id: 'workspaces' as MasterTab, icon: Building2, label: 'Workspaces' },
  { id: 'cobrancas' as MasterTab, icon: Wallet, label: 'Cobranças' },
  { id: 'auditoria' as MasterTab, icon: ShieldCheck, label: 'Auditoria' },
  { id: 'config' as MasterTab, icon: Settings, label: 'Config' },
] as const;

/**
 * Tab bar Master mobile — 5 colunas, acento lilás (sem FAB).
 * Touch targets >= 44px.
 */
export function MasterTabBar({ current, onChange }: MasterTabBarProps) {
  return (
    <div
      role="navigation"
      aria-label="Navegação Master"
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(5, 1fr)',
        alignItems: 'center',
        borderTop: '1px solid var(--card-stroke)',
        background: 'var(--frame)',
        padding: '6px 6px 24px',
        flexShrink: 0,
      }}
    >
      {TABS.map(({ id, icon: Icon, label }) => {
        const active = current === id;
        return (
          <button
            key={id}
            onClick={() => onChange(id)}
            aria-label={label}
            aria-current={active ? 'page' : undefined}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 3,
              padding: '6px 0',
              minHeight: 44,
              color: active ? 'var(--lilac-deep)' : 'var(--fg-dim)',
              background: 'none',
              border: 0,
              cursor: 'pointer',
              font: 'inherit',
              transition: 'color 120ms',
            }}
          >
            <Icon size={20} strokeWidth={active ? 2 : 1.6} />
            <span style={{ fontSize: 9.5, fontWeight: active ? 700 : 500 }}>{label}</span>
          </button>
        );
      })}
    </div>
  );
}
